__turbopack_context__.v({
  "center": "style-module-scss-module__bDSnuW__center",
  "container": "style-module-scss-module__bDSnuW__container",
  "content": "style-module-scss-module__bDSnuW__content",
  "cta": "style-module-scss-module__bDSnuW__cta",
  "description": "style-module-scss-module__bDSnuW__description",
  "eyebrow": "style-module-scss-module__bDSnuW__eyebrow",
  "image": "style-module-scss-module__bDSnuW__image",
  "imageContainer": "style-module-scss-module__bDSnuW__imageContainer",
  "inView": "style-module-scss-module__bDSnuW__inView",
  "left": "style-module-scss-module__bDSnuW__left",
  "media": "style-module-scss-module__bDSnuW__media",
  "right": "style-module-scss-module__bDSnuW__right",
  "title": "style-module-scss-module__bDSnuW__title",
});
